import {
  AuthMiddleware,
  DashboardMiddleWare,
  userMiddleWarre,
} from "../middlewares";
import { takeLatest, all, take } from "redux-saga/effects";
import {
  SIGNIN,
  SIGNUP,
  SIGNOUT,
  VERIFICATION_CODE,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  DASHBOARD_COUNT_REQ,
  GET_ORDER_REQ,
  GET_USER_REQ,
  CREATE_USER_REQ,
  GET_ALLCUSTOMER_REQ,
  GET_USER_DETAIL_REQ,
  GET_COMPANY_DETAIL_REQ,
  GET_LOCATION_REQ,
  GET_CARD_REQ,
  ALLOW_CUSTOMER_REQ,
  RESTRICT_CUSTOMER_REQ,
  GET_PRODUCT_REQ,
  // GET_CATEGORIES_REQ,
  GET_SHIPPINGCOST_REQ,
  UPDATE_SHIPPINGCOST_REQ,
  GET_CATEGORIES_REQ,
  CREATE_LOCATION_REQ,
  DELETE_LOCATION_REQ,
  UPDATE_LOCATION_REQ,
  UPDATE_ASSETS_REQ,
  UPDATE_BUSINESS_INFO_REQ,
  UPDATE_PROFILE_INFO_REQ,
  UPDATE_PRODUCT_REQ,
  GET_ORDER_BY_ID_REQ,
  ORDER_APPROVAL_REQ,
  POST_PRODUCT_REQ,
  POST_CUSTOMPRODUCT_SUCCESS,
  GET_BASEMIX_CATEGORIES_SUCCESS,
  GET_BASEMIX_CATEGORIES_REQ,
  GET_BASEMIXES_REQ,
  GET_ADDITIVES_REQ,
  GET_BASEMIXES_CATEGORIES_REQ,
  POST_BASEMIX_REQ,
  POST_CUSTOMPRODUCT_REQ,
  DELETE_DOC_REQ,
  UPLOAD_DOC_REQ,
  GET_NOTIFICATION_REQ,
  IS_READ_REQ,
  GET_LOGISTICS_REQ,
  GET_LOG_PARTNER_REQ,
  MARK_AS_FAV_REQ,
  VALIDATION_REQ,
  GET_TEMPLATE_REQ,
  CREATE_ASSETS_REQ,
  POST_FILE_REQ,
  DELETE_CARD_REQ,
  SET_CARD_DEFAULT_REQ,
  GET_STORE_URL_REQ,
  POST_SHIPPINGCOST_REQ,
  VERIFY_ZIP_CODE_REQ,
  CREATE_TOKEN_REQ,
  CREATE_CARD_REQ,
  GET_SUBSCRIPTION_PLAN_REQ,
  CREATE_SUBSCRIPTION_REQ,
  SHARE_RECIPT_REQ,
  DOWNLOAD_RECIPT_REQ,
  DELETE_LOGISTICS_PARTNER_REQ,
  USER_AUTHENTICATION_REQ,
  CONNECT_STRIPE_REQ,
} from "../constants";
import CatalogMiddleWare from "../middlewares/CatalogMiddleware";
import { AuthAction, CatalogAction } from "../actions";

export function* Sagas() {
  yield all([
    yield takeLatest(SIGNIN, AuthMiddleware.SignIn),
    yield takeLatest(SIGNUP, AuthMiddleware.SignUp),
    yield takeLatest(SIGNOUT, AuthMiddleware.SignOut),
    yield takeLatest(VERIFICATION_CODE, AuthMiddleware.VerifyCode),
    yield takeLatest(FORGOT_PASSWORD, AuthMiddleware.ForgotPassword),
    yield takeLatest(RESET_PASSWORD, AuthMiddleware.ResetPassword),
    yield takeLatest(DASHBOARD_COUNT_REQ, DashboardMiddleWare.DashboardCount),
    yield takeLatest(GET_ORDER_REQ, DashboardMiddleWare.DashboardOrders),
    yield takeLatest(GET_USER_REQ, userMiddleWarre.getUserMiddleWare),
    yield takeLatest(CREATE_USER_REQ, userMiddleWarre.createUserMiddleWare),
    yield takeLatest(GET_ALLCUSTOMER_REQ, DashboardMiddleWare.AllCustomer),
    yield takeLatest(
      GET_USER_DETAIL_REQ,
      userMiddleWarre.getUserDetailMiddleWare
    ),
    yield takeLatest(GET_COMPANY_DETAIL_REQ, userMiddleWarre.getCompanyDetails),
    yield takeLatest(GET_LOCATION_REQ, userMiddleWarre.getLocationMiddleWare),
    yield takeLatest(GET_CARD_REQ, userMiddleWarre.getCardsMiddleWare),
    yield takeLatest(ALLOW_CUSTOMER_REQ, DashboardMiddleWare.AllowCustomer),
    yield takeLatest(
      RESTRICT_CUSTOMER_REQ,
      DashboardMiddleWare.RestrictCustomer
    ),
    yield takeLatest(GET_PRODUCT_REQ, CatalogMiddleWare.CatalogProduct),
    yield takeLatest(GET_SHIPPINGCOST_REQ, CatalogMiddleWare.GetShipingCost),
    yield takeLatest(UPDATE_SHIPPINGCOST_REQ, CatalogMiddleWare.ShipingCost),
    yield takeLatest(GET_CATEGORIES_REQ, CatalogMiddleWare.GetCategories),
    yield takeLatest(
      CREATE_LOCATION_REQ,
      userMiddleWarre.createLocationMiddleWare
    ),
    yield takeLatest(
      DELETE_LOCATION_REQ,
      userMiddleWarre.deleteLocationMiddleWare
    ),
    yield takeLatest(
      UPDATE_LOCATION_REQ,
      userMiddleWarre.updateLocationMiddleWare
    ),
    yield takeLatest(UPDATE_ASSETS_REQ, userMiddleWarre.updateAssetsMiddleWare),
    yield takeLatest(
      UPDATE_BUSINESS_INFO_REQ,
      userMiddleWarre.updateBusinessInfoMiddleare
    ),
    yield takeLatest(
      UPDATE_PROFILE_INFO_REQ,
      userMiddleWarre.updateProfileInfoMiddleare
    ),
    yield takeLatest(UPDATE_PRODUCT_REQ, CatalogMiddleWare.UpdateProduct),
    yield takeLatest(
      GET_ORDER_BY_ID_REQ,
      DashboardMiddleWare.getOrderDetailById
    ),
    yield takeLatest(
      ORDER_APPROVAL_REQ,
      DashboardMiddleWare.orderAprovalMiddleWare
    ),

    yield takeLatest(POST_PRODUCT_REQ, CatalogMiddleWare.PostProduct),
    yield takeLatest(POST_CUSTOMPRODUCT_REQ, CatalogMiddleWare.CustomProduct),
    yield takeLatest(
      GET_BASEMIX_CATEGORIES_REQ,
      CatalogMiddleWare.GetBasemixCategories
    ),
    yield takeLatest(GET_BASEMIXES_REQ, CatalogMiddleWare.GetBasemixes),
    yield takeLatest(GET_ADDITIVES_REQ, CatalogMiddleWare.GetAddivites),
    yield takeLatest(
      GET_BASEMIXES_CATEGORIES_REQ,
      CatalogMiddleWare.GetBasemixesCategories
    ),
    yield takeLatest(POST_BASEMIX_REQ, CatalogMiddleWare.PostBasemix),
    yield takeLatest(DELETE_DOC_REQ, DashboardMiddleWare.deleteDocMiddleWare),
    yield takeLatest(UPLOAD_DOC_REQ, DashboardMiddleWare.uploadDocMiddleWare),
    yield takeLatest(
      GET_NOTIFICATION_REQ,
      DashboardMiddleWare.getNotificationMiddleWare
    ),
    yield takeLatest(IS_READ_REQ, DashboardMiddleWare.markAsReadMiddleWare),
    yield takeLatest(
      GET_LOGISTICS_REQ,
      DashboardMiddleWare.getLogisticsMiddleWare
    ),
    yield takeLatest(
      GET_LOG_PARTNER_REQ,
      DashboardMiddleWare.getLogPartberMiddleWare
    ),
    yield takeLatest(MARK_AS_FAV_REQ, DashboardMiddleWare.markAsFavMiddleWare),
    yield takeLatest(GET_TEMPLATE_REQ, CatalogMiddleWare.GetTemplateReq),
    yield takeLatest(CREATE_ASSETS_REQ, userMiddleWarre.createAssetsMiddleare),
    yield takeLatest(POST_FILE_REQ, CatalogMiddleWare.PostFile),
    yield takeLatest(VALIDATION_REQ, AuthMiddleware.validationMiddleware),
    yield takeLatest(DELETE_CARD_REQ, userMiddleWarre.deleteCardMiddleware),
    yield takeLatest(DELETE_CARD_REQ, userMiddleWarre.deleteCardMiddleware),
    yield takeLatest(
      SET_CARD_DEFAULT_REQ,
      userMiddleWarre.setDefaultCardMiddleware
    ),
    yield takeLatest(GET_STORE_URL_REQ, AuthMiddleware.storeUrlMiddleware),
    yield takeLatest(POST_SHIPPINGCOST_REQ, CatalogMiddleWare.postShipingCost),
    yield takeLatest(
      VERIFY_ZIP_CODE_REQ,
      userMiddleWarre.verifyZipcodeMiddleware
    ),
    yield takeLatest(CREATE_TOKEN_REQ, userMiddleWarre.createTokenMiddleware),
    yield takeLatest(CREATE_CARD_REQ, userMiddleWarre.createCardMiddleware),
    yield takeLatest(
      GET_SUBSCRIPTION_PLAN_REQ,
      userMiddleWarre.getSubscriptionPlanMiddleware
    ),
    yield takeLatest(
      CREATE_SUBSCRIPTION_REQ,
      userMiddleWarre.createSubscriptionMiddleWare
    ),
    yield takeLatest(
      DOWNLOAD_RECIPT_REQ,
      userMiddleWarre.downloadReciptMiddleware
    ),
    yield takeLatest(SHARE_RECIPT_REQ, userMiddleWarre.shareReciptMiddleware),
    yield takeLatest(
      DELETE_LOGISTICS_PARTNER_REQ,
      DashboardMiddleWare.deletLogisticsMiddleWare
    ),
    yield takeLatest(USER_AUTHENTICATION_REQ, AuthMiddleware.UserAuthenticationMiddleWare),
    yield takeLatest(CONNECT_STRIPE_REQ, userMiddleWarre.connectStripeMiddleware)
  ]);
}
